import { useMemo } from 'react'

export const useAllPurchased = (contents) => {
  return useMemo(() => {
    const normalContents = contents.filter((content) => !content.read_period_content_flag)
    return normalContents.every((content) => content.purchased === true)
  }, [contents])
}
